import { render, staticRenderFns } from "./status-chicklet.vue?vue&type=template&id=22965956&"
import script from "./status-chicklet.vue?vue&type=script&lang=ts&"
export * from "./status-chicklet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports